import { ImageGalleryType } from '../../../components/ImageGallery/ImageGallery';
import { BannerId } from '../../../typings/banners';
import { InternalResourceId } from '../../../typings/internalBanners';

export const SHOW_IMAGE_INTERNAL_GALLERY = 'SHOW_IMAGE_INTERNAL_GALLERY';
export type SHOW_IMAGE_INTERNAL_GALLERY = typeof SHOW_IMAGE_INTERNAL_GALLERY;

export interface ShowImageInternalGallery {
    type: SHOW_IMAGE_INTERNAL_GALLERY;
    bannerId: BannerId;
    resourceId: InternalResourceId;
    galleryType: ImageGalleryType;
}

export function showImageInternalGalleryAction(
    bannerId: BannerId,
    resourceId: InternalResourceId,
    galleryType: ImageGalleryType
): ShowImageInternalGallery {
    return {
        type: SHOW_IMAGE_INTERNAL_GALLERY,
        bannerId,
        resourceId,
        galleryType
    };
}
